<template>
  <div>
    
    <br />
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="Code">Email:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="user1.email"
        ></InputText>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="Name">Last Login Date:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="user1.lastLoginDate"
        ></InputText>
      </div>
    </div>
    
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="Name">First Name:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="user1.firstName"
        ></InputText>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="Name">Last Name:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="user1.lastName"
        ></InputText>
      </div>
    </div>

    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="Branch">Department:</label>
        <InputText
          class="clearer"
          v-if="user1.mbpDept"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="user1.mbpDept.deptName"
        ></InputText>
        <InputText
          v-else
          type="text"
          placeholder=""
          :disabled="true"
        ></InputText>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="Branch">Supervisor:</label>
        <InputText
          class="clearer"
          v-if="user1.supervisor"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="user1.supervisor.fullName"
        ></InputText>
        <InputText
          v-else
          type="text"
          placeholder=""
          :disabled="true"
        ></InputText>
      </div>
    </div>
    
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="Branch">Region:</label>
        <InputText
          class="clearer"
          v-if="user1.defRegion"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="user1.defRegion.regionName"
        ></InputText>
        <InputText
          v-else
          type="text"
          placeholder=""
          :disabled="true"
        ></InputText>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="Branch">Branch:</label>
        <InputText
          class="clearer"
          v-if="user1.defBranch"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="user1.defBranch.branchName"
        ></InputText>
        <InputText
          v-else
          type="text"
          placeholder=""
          :disabled="true"
        ></InputText>
      </div>
    </div>
    
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="Branch">Sales Exec:</label>
        <InputText
          class="clearer"
          v-if="user1.salesExec"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="user1.salesExec.salesExecName"
        ></InputText>
        <InputText
          v-else
          type="text"
          placeholder=""
          :disabled="true"
        ></InputText>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="Branch">Role:</label>
        <InputText
          class="clearer"
          v-if="user1.role"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="user1.role.roleName"
        ></InputText>
        <InputText
          v-else
          type="text"
          placeholder=""
          :disabled="true"
        ></InputText>
      </div>
    </div>

    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="createdBy">Created By:</label>
        <InputText
          class="clearer"
          v-if="user1.createdBy"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="user1.createdBy.fullName"
        ></InputText>
        <InputText
          v-else
          type="text"
          placeholder=""
          :disabled="true"
        ></InputText>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="created">Date Created:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="user1.dateCreated"
        ></InputText>
      </div>
    </div>

    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="updatedBy">Updated By:</label>
        <InputText
          class="clearer"
          v-if="user1.updatedBy"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="user1.updatedBy.fullName"
        ></InputText>
        <InputText
          v-else
          type="text"
          placeholder=""
          :disabled="true"
        ></InputText>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="updated">Date Updated:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="user1.dateUpdated"
        ></InputText>
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="tagType">Get task and event reminder emails</label>
        <br />
        <InputSwitch 
          :disabled="true"
          v-model="user1.getReminderEmail" 
        />
      </div>
      <div class="p-field p-col">
        <label for="tagType">Get notes emails</label>
        <br />
        <InputSwitch 
          :disabled="true"
          v-model="user1.getNotesEmail" 
        />
      </div>
      <div class="p-field p-col">
        <label for="tagType">Get customer approval emails</label>
        <br />
        <InputSwitch 
          :disabled="true"
          v-model="user1.getCustApproveEmail" 
        />
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="createOutlookActivity">Create Outlook Event</label>
        <br />
        <InputSwitch 
          v-model="user.createOutlookActivity" 
          :disabled="true"
        />
      </div>
      <div class="p-field p-col">
        <label for="outlookTodoSync">Microsoft To Do (tasks)</label>
        <br />
        <InputSwitch id="outlookTodoSync" v-model="user1.outlookTodoSync" :disabled="true" />
      </div>
    </div>
    <OutlookUserSyncStatus v-if="user1 && user1.id" :userId="user1.id" />

  </div>
</template>

<script>
import OutlookUserSyncStatus from "@/mbp/outlookSync/OutlookUserSyncStatus.vue";

export default {
  components: { OutlookUserSyncStatus },
  created() {
    this.user1 = {...this.user}
  },
  props: ["user"],
  data: () => ({
    user1: {}
  }),
  watch: {
    user(val) {
      this.user1 = val
    }
  }
}

</script>